import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../service/category.service';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { SelectedProductService } from '../../main-content/sevices/selected-product.service';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../_services';
import { User } from '../../_models';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public categories: any = [];
  currentUser: User;
  searchText: any = '';
  constructor(private categoryService: CategoryService, private selectedProductService: SelectedProductService, private router: Router,
    private authenticationService: AuthenticationService) {
    //this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }
   companyLogo = '';

  ngOnInit(): void {
    this.companyLogo = environment.compantLogo;
    this.categoryService.getCategories().subscribe(res => {
      this.categories = res;
    });
  }
  get count() {
    return this.selectedProductService.items.length
  }
 
  searchForString(): void {
 environment.compantLogo
    this.selectedProductService.addSearch(this.searchText);
    this.router.navigateByUrl("/products");
  }

}
